var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_1870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9938 53.2595C24.9938 53.2595 22.1172 53.2595 22.1172 50.3829C22.1172 47.5062 24.9938 38.8764 36.5002 38.8764C48.0066 38.8764 50.8832 47.5062 50.8832 50.3829C50.8832 53.2595 48.0066 53.2595 48.0066 53.2595H24.9938ZM36.5002 35.9998C38.789 35.9998 40.984 35.0906 42.6024 33.4722C44.2208 31.8538 45.13 29.6588 45.13 27.37C45.13 25.0813 44.2208 22.8862 42.6024 21.2678C40.984 19.6494 38.789 18.7402 36.5002 18.7402C34.2114 18.7402 32.0164 19.6494 30.398 21.2678C28.7796 22.8862 27.8704 25.0813 27.8704 27.37C27.8704 29.6588 28.7796 31.8538 30.398 33.4722C32.0164 35.0906 34.2114 35.9998 36.5002 35.9998Z",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7.5,
    width: 57,
    height: 57,
    rx: 28.5,
    stroke: "#F3F4F6",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_1870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(6.5 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.a18a9f6b5bcb10fe9386cb6acf9b7504.svg";
export { ForwardRef as ReactComponent };